// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import type { AvailablePlayer, Player } from './types';

export const normalizeDebugParam = (debugParam?: string | string[]) => {
  const raw = Array.isArray(debugParam) ? debugParam[0] : debugParam;
  return raw === 'true';
};

export const deriveInitialTourId = (tourParam: string | string[] | undefined, storedTourId: string | null) => {
  const raw = Array.isArray(tourParam) ? tourParam[0] : tourParam;
  const candidate = raw?.trim() || storedTourId;
  if (!candidate) return null;
  if (candidate === '00000000-0000-0000-0000-000000000000') return null;
  return candidate;
};

export const buildPlayerOrder = (
  incomingPlayers: Player[],
  currentUserPlayer: AvailablePlayer | undefined,
  createId: () => string
) => {
  const orderedPlayers: Player[] = [];
  if (currentUserPlayer) {
    orderedPlayers.push({
      id: currentUserPlayer.id,
      name: currentUserPlayer.name,
      scp: incomingPlayers.find((player) => player.id === currentUserPlayer.id)?.scp ?? '',
    });
  }
  incomingPlayers.forEach((player) => {
    if (currentUserPlayer && player.id === currentUserPlayer.id) return;
    orderedPlayers.push(player);
  });
  return orderedPlayers.length ? orderedPlayers.slice(0, 12) : [{ id: createId(), name: '', scp: '' }];
};

export const buildEmptyScpIds = (players: Player[], availablePlayerIdSet: Set<string>) =>
  players
    .filter((player) => !player.scp.trim() && availablePlayerIdSet.has(player.id))
    .map((player) => player.id)
    .sort();
